// // components/TermsAndConditions.jsx
// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { 
//   getAllTerms, 
//   getTermsById,
//   createTerms, 
//   updateTerms, 
//   toggleTermsStatus,
//   getTermsHistory 
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/TermsManage.css';

// // Icons
// import { 
//   FiEye, FiEdit2, FiClock, FiToggleLeft, FiToggleRight,
//   FiSearch, FiFilter, FiRefreshCw, FiDownload, FiPlus,
//   FiTrash2, FiChevronLeft, FiChevronRight, FiX,
//   FiCheck, FiAlertCircle, FiInfo, FiFileText,
//   FiCalendar, FiUser, FiTag, FiLayers
// } from 'react-icons/fi';

// const TermsAndConditions = () => {
//   const { token } = useSelector(state => state.user);
//   const [terms, setTerms] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterType, setFilterType] = useState('');
//   const [editingTerms, setEditingTerms] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingTerms, setViewingTerms] = useState(null);
//   const [viewingHistory, setViewingHistory] = useState(null);
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showHistoryModal, setShowHistoryModal] = useState(false);
//   const [newTermsForm, setNewTermsForm] = useState({
//     type: '',
//     title: '',
//     sections: [{ title: '', content: '' }],
//     effectiveDate: new Date().toISOString().split('T')[0]
//   });
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);
//   const [selectedHistory, setSelectedHistory] = useState(null);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalTerms, setTotalTerms] = useState(0);
//   const [pageSize] = useState(10);

//   // Types of terms
//   const termTypes = [
//     { value: '', label: 'All Types', icon: '📄', color: '#6366f1' },
//     { value: 'general', label: 'General Terms', icon: '📋', color: '#10b981' },
//     { value: 'passenger', label: 'Passenger Terms', icon: '👤', color: '#3b82f6' },
//     { value: 'bus_owner', label: 'Bus Owner Terms', icon: '🚌', color: '#f59e0b' },
//     { value: 'privacy', label: 'Privacy Policy', icon: '🔒', color: '#8b5cf6' },
//     { value: 'cookie', label: 'Cookie Policy', icon: '🍪', color: '#ec4899' },
//     { value: 'refund', label: 'Refund Policy', icon: '💸', color: '#ef4444' }
//   ];

//   useEffect(() => {
//     fetchTerms();
//   }, [currentPage, searchTerm, filterType]);

//   const fetchTerms = async () => {
//     try {
//       setLoading(true);
//       const response = await getAllTerms(token, currentPage, pageSize, filterType);

//       if (response && response.success) {
//         const transformedTerms = response.terms.map((term, index) => ({
//           id: term._id || term.id,
//           serialNo: (currentPage - 1) * pageSize + index + 1,
//           type: term.type,
//           typeLabel: getTypeLabel(term.type),
//           typeColor: getTypeColor(term.type),
//           typeIcon: getTypeIcon(term.type),
//           title: term.title,
//           version: term.version,
//           isActive: term.isActive,
//           effectiveDate: new Date(term.effectiveDate).toLocaleDateString('en-US'),
//           lastUpdated: new Date(term.updatedAt || term.lastUpdatedAt).toLocaleDateString('en-US'),
//           lastUpdatedBy: term.lastUpdatedBy?.name || 'System Admin',
//           content: term.content
//         }));

//         setTerms(transformedTerms);
//         setTotalPages(response.totalPages || 1);
//         setTotalTerms(response.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch terms and conditions.');
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getTypeLabel = (type) => {
//     const typeMap = {
//       'general': 'General Terms',
//       'passenger': 'Passenger Terms',
//       'bus_owner': 'Bus Owner Terms',
//       'privacy': 'Privacy Policy',
//       'cookie': 'Cookie Policy',
//       'refund': 'Refund Policy'
//     };
//     return typeMap[type] || type;
//   };

//   const getTypeColor = (type) => {
//     const colorMap = {
//       'general': '#10b981',
//       'passenger': '#3b82f6',
//       'bus_owner': '#f59e0b',
//       'privacy': '#8b5cf6',
//       'cookie': '#ec4899',
//       'refund': '#ef4444'
//     };
//     return colorMap[type] || '#6b7280';
//   };

//   const getTypeIcon = (type) => {
//     const iconMap = {
//       'general': '📋',
//       'passenger': '👤',
//       'bus_owner': '🚌',
//       'privacy': '🔒',
//       'cookie': '🍪',
//       'refund': '💸'
//     };
//     return iconMap[type] || '📄';
//   };

//   const handleViewTerms = async (term) => {
//     try {
//       const response = await getTermsById(term.id, token);
//       if (response.success) {
//         // Parse content to extract sections
//         const sections = parseContentToSections(response.terms.content);
//         setViewingTerms({
//           ...term,
//           sections: sections.length > 0 ? sections : [{ title: 'Full Terms', content: response.terms.content }]
//         });
//       }
//     } catch (err) {
//       setError('Failed to fetch term details.');
//     }
//   };

//   const parseContentToSections = (content) => {
//     const sections = [];
//     if (!content) return sections;
    
//     // Try to parse the structured format
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(content, 'text/html');
//     const sectionElements = doc.querySelectorAll('.terms-section');
    
//     if (sectionElements.length > 0) {
//       sectionElements.forEach((sectionEl, index) => {
//         const titleEl = sectionEl.querySelector('.section-title');
//         const contentEl = sectionEl.querySelector('.section-content');
        
//         if (titleEl && contentEl) {
//           // Extract number from title (e.g., "1. Acceptance of Terms")
//           const titleText = titleEl.textContent.replace(/^\d+\.\s*/, '');
//           sections.push({
//             title: titleText,
//             content: contentEl.innerHTML
//           });
//         }
//       });
//     }
    
//     return sections;
//   };

//   const handleViewHistory = async (termId, termTitle) => {
//     try {
//       const response = await getTermsHistory(termId, token);
//       if (response.success) {
//         setSelectedHistory({
//           termId,
//           termTitle,
//           history: response.history || []
//         });
//         setShowHistoryModal(true);
//       }
//     } catch (err) {
//       setError('Failed to fetch history.');
//     }
//   };

//   const handleCreateNew = () => {
//     setShowCreateModal(true);
//     setNewTermsForm({
//       type: '',
//       title: '',
//       sections: [
//         { 
//           title: 'Acceptance of Terms', 
//           content: 'By accessing and using this website, you agree to be bound by these terms and conditions.' 
//         },
//         { 
//           title: 'User Responsibilities', 
//           content: 'Users must provide accurate information and use the service responsibly.' 
//         }
//       ],
//       effectiveDate: new Date().toISOString().split('T')[0]
//     });
//   };

//   const handleAddSection = () => {
//     setNewTermsForm({
//       ...newTermsForm,
//       sections: [...newTermsForm.sections, { title: '', content: '' }]
//     });
//   };

//   const handleRemoveSection = (index) => {
//     if (newTermsForm.sections.length > 1) {
//       const newSections = [...newTermsForm.sections];
//       newSections.splice(index, 1);
//       setNewTermsForm({
//         ...newTermsForm,
//         sections: newSections
//       });
//     }
//   };

//   const handleSectionChange = (index, field, value) => {
//     const newSections = [...newTermsForm.sections];
//     newSections[index][field] = value;
//     setNewTermsForm({
//       ...newTermsForm,
//       sections: newSections
//     });
//   };

//   const handleCreateSubmit = async () => {
//     try {
//       setError(null);
      
//       if (!newTermsForm.type || !newTermsForm.title || !newTermsForm.sections.length) {
//         setError('Please fill all required fields');
//         return;
//       }

//       // Validate sections
//       for (let i = 0; i < newTermsForm.sections.length; i++) {
//         if (!newTermsForm.sections[i].title.trim() || !newTermsForm.sections[i].content.trim()) {
//           setError(`Please fill both header and content for section ${i + 1}`);
//           return;
//         }
//       }

//       const response = await createTerms(newTermsForm, token);
      
//       if (response.success) {
//         setSuccess('Terms and conditions created successfully!');
//         setShowCreateModal(false);
//         fetchTerms();
//         setTimeout(() => setSuccess(null), 3000);
//       } else {
//         setError(response.message || 'Failed to create terms');
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to create terms');
//     }
//   };

//   const handleEditTerms = async (term) => {
//     try {
//       const response = await getTermsById(term.id, token);
//       if (response.success) {
//         const sections = parseContentToSections(response.terms.content);
//         setEditingTerms(term.id);
//         setEditForm({
//           title: term.title,
//           sections: sections.length > 0 ? sections : [{ title: 'Terms and Conditions', content: response.terms.content }],
//           isActive: term.isActive,
//           effectiveDate: new Date(term.effectiveDate).toISOString().split('T')[0],
//           changeReason: ''
//         });
//         setShowEditModal(true);
//       }
//     } catch (err) {
//       setError('Failed to load term for editing.');
//     }
//   };

//   const handleEditSectionChange = (index, field, value) => {
//     const newSections = [...editForm.sections];
//     newSections[index][field] = value;
//     setEditForm({
//       ...editForm,
//       sections: newSections
//     });
//   };

//   const handleAddEditSection = () => {
//     setEditForm({
//       ...editForm,
//       sections: [...editForm.sections, { title: '', content: '' }]
//     });
//   };

//   const handleRemoveEditSection = (index) => {
//     if (editForm.sections.length > 1) {
//       const newSections = [...editForm.sections];
//       newSections.splice(index, 1);
//       setEditForm({
//         ...editForm,
//         sections: newSections
//       });
//     }
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);

//       if (!editForm.changeReason) {
//         setError('Please provide a change reason for this update');
//         return;
//       }

//       // Validate sections
//       for (let i = 0; i < editForm.sections.length; i++) {
//         if (!editForm.sections[i].title.trim() || !editForm.sections[i].content.trim()) {
//           setError(`Please fill both header and content for section ${i + 1}`);
//           return;
//         }
//       }

//       const updateData = {
//         title: editForm.title,
//         sections: editForm.sections,
//         effectiveDate: editForm.effectiveDate,
//         isActive: editForm.isActive,
//         changeReason: editForm.changeReason
//       };

//       const response = await updateTerms(editingTerms, updateData, token);

//       if (response.success) {
//         setSuccess('Terms updated successfully!');
//         setEditingTerms(null);
//         setEditForm({});
//         setShowEditModal(false);
//         fetchTerms();
//         setTimeout(() => setSuccess(null), 3000);
//       } else {
//         setError(response.message || 'Failed to update terms');
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to update terms');
//     }
//   };

//   const handleToggleStatus = async (termId, currentStatus) => {
//     try {
//       setError(null);
//       const response = await toggleTermsStatus(termId, token);
      
//       if (response.success) {
//         setSuccess(`Terms ${currentStatus ? 'deactivated' : 'activated'} successfully!`);
//         fetchTerms();
//         setTimeout(() => setSuccess(null), 3000);
//       }
//     } catch (err) {
//       setError('Failed to update status');
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleTypeFilter = (e) => {
//     setFilterType(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleRefresh = () => {
//     setCurrentPage(1);
//     fetchTerms();
//   };

//   const handleExportCSV = () => {
//     if (terms.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['ID', 'Type', 'Title', 'Version', 'Status', 'Effective Date', 'Last Updated', 'Updated By'];
//     const csvData = terms.map(term => [
//       term.id,
//       term.typeLabel,
//       term.title,
//       term.version,
//       term.isActive ? 'Active' : 'Inactive',
//       term.effectiveDate,
//       term.lastUpdated,
//       term.lastUpdatedBy
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `terms-and-conditions-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   // Get status badge
//   const getStatusBadge = (isActive) => {
//     return (
//       <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
//         <span className="status-dot"></span>
//         {isActive ? 'Active' : 'Inactive'}
//       </span>
//     );
//   };

//   // Pagination handlers
//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Close modals
//   const closeViewModal = () => {
//     setViewingTerms(null);
//   };

//   const closeHistoryModal = () => {
//     setShowHistoryModal(false);
//     setSelectedHistory(null);
//   };

//   const closeCreateModal = () => {
//     setShowCreateModal(false);
//     setNewTermsForm({
//       type: '',
//       title: '',
//       sections: [{ title: '', content: '' }],
//       effectiveDate: new Date().toISOString().split('T')[0]
//     });
//   };

//   const closeEditModal = () => {
//     setShowEditModal(false);
//     setEditingTerms(null);
//     setEditForm({});
//   };

//   const filterTerms = terms.filter(term => 
//     term.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     term.typeLabel.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const getTypeIconComponent = (type) => {
//     return termTypes.find(t => t.value === type)?.icon || '📄';
//   };

//   if (loading) {
//     return (
//       <div className="terms-management-page">
//         <div className="loading-overlay">
//           <div className="loading-spinner"></div>
//           <p>Loading terms and conditions...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="terms-management-page">
//       {/* Header */}
//       <div className="terms-header">
//         <div className="header-left">
//           <h1><FiFileText /> Terms & Conditions</h1>
//           <p className="subtitle">Manage all terms, policies, and agreements</p>
//         </div>
//         <div className="header-right">
//           <button className="btn btn-primary" onClick={handleCreateNew}>
//             <FiPlus /> Create New
//           </button>
//         </div>
//       </div>

//       {/* Stats Cards */}
//       <div className="terms-stats-grid">
//         <div className="stat-card">
//           <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
//             <FiLayers />
//           </div>
//           <div className="stat-content">
//             <h3>{totalTerms}</h3>
//             <p>Total Terms</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)' }}>
//             <FiCheck />
//           </div>
//           <div className="stat-content">
//             <h3>{terms.filter(t => t.isActive).length}</h3>
//             <p>Active</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)' }}>
//             <FiTag />
//           </div>
//           <div className="stat-content">
//             <h3>{[...new Set(terms.map(t => t.type))].length}</h3>
//             <p>Types</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)' }}>
//             <FiClock />
//           </div>
//           <div className="stat-content">
//             <h3>v{Math.max(...terms.map(t => t.version || 1))}</h3>
//             <p>Latest Version</p>
//           </div>
//         </div>
//       </div>

//       {/* Filters and Search */}
//       <div className="filters-section">
//         <div className="search-box">
//           <FiSearch className="search-icon" />
//           <input
//             type="text"
//             placeholder="Search terms by title or type..."
//             value={searchTerm}
//             onChange={handleSearchChange}
//             className="search-input"
//           />
//         </div>
//         <div className="filter-actions">
//           <div className="filter-group">
//             <FiFilter className="filter-icon" />
//             <select
//               className="filter-select"
//               value={filterType}
//               onChange={handleTypeFilter}
//             >
//               {termTypes.map(type => (
//                 <option key={type.value} value={type.value}>
//                   {type.label}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <button className="btn btn-secondary" onClick={handleRefresh}>
//             <FiRefreshCw /> Refresh
//           </button>
//           <button className="btn btn-outline" onClick={handleExportCSV}>
//             <FiDownload /> Export
//           </button>
//         </div>
//       </div>

//       {/* Terms Table */}
//       <div className="terms-table-container">
//         <div className="table-responsive">
//           <table className="modern-table">
//             <thead>
//               <tr>
//                 <th className="text-center">#</th>
//                 <th>Type</th>
//                 <th>Title & Details</th>
//                 <th className="text-center">Version</th>
//                 <th className="text-center">Status</th>
//                 <th>Last Updated</th>
//                 <th className="text-center">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filterTerms.map(term => (
//                 <tr key={term.id}>
//                   <td className="text-center">{term.serialNo}</td>
//                   <td>
//                     <div className="type-badge" style={{ backgroundColor: term.typeColor + '15', color: term.typeColor, borderColor: term.typeColor + '40' }}>
//                       <span className="type-icon">{term.typeIcon}</span>
//                       {term.typeLabel}
//                     </div>
//                   </td>
//                   <td>
//                     <div className="term-info">
//                       <h4 className="term-title">{term.title}</h4>
//                       <div className="term-meta">
//                         <span className="meta-item">
//                           <FiCalendar /> {term.effectiveDate}
//                         </span>
//                         <span className="meta-item">
//                           <FiUser /> {term.lastUpdatedBy}
//                         </span>
//                       </div>
//                     </div>
//                   </td>
//                   <td className="text-center">
//                     <span className="version-badge">v{term.version}</span>
//                   </td>
//                   <td className="text-center">
//                     {getStatusBadge(term.isActive)}
//                   </td>
//                   <td>
//                     <div className="update-info">
//                       <div className="update-date">{term.lastUpdated}</div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewTerms(term)}
//                         title="View Details"
//                       >
//                         <FiEye />
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleEditTerms(term)}
//                         title="Edit"
//                       >
//                         <FiEdit2 />
//                       </button>
//                       <button
//                         className="action-btn history"
//                         onClick={() => handleViewHistory(term.id, term.title)}
//                         title="View History"
//                       >
//                         <FiClock />
//                       </button>
//                       <button
//                         className={`action-btn ${term.isActive ? 'deactivate' : 'activate'}`}
//                         onClick={() => handleToggleStatus(term.id, term.isActive)}
//                         title={term.isActive ? 'Deactivate' : 'Activate'}
//                       >
//                         {term.isActive ? <FiToggleRight /> : <FiToggleLeft />}
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {filterTerms.length === 0 && !loading && (
//           <div className="empty-state">
//             <div className="empty-icon">📄</div>
//             <h3>No Terms Found</h3>
//             <p>No terms and conditions match your search criteria.</p>
//             <button className="btn btn-primary" onClick={handleCreateNew}>
//               <FiPlus /> Create Your First Terms
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Pagination */}
//       {filterTerms.length > 0 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing <strong>{filterTerms.length}</strong> of <strong>{totalTerms}</strong> terms • Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
//           </div>
//           <div className="pagination-controls">
//             <button
//               className="pagination-btn prev"
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               <FiChevronLeft /> Previous
//             </button>
//             <div className="page-numbers">
//               {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                 let pageNumber;
//                 if (totalPages <= 5) {
//                   pageNumber = i + 1;
//                 } else if (currentPage <= 3) {
//                   pageNumber = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   pageNumber = totalPages - 4 + i;
//                 } else {
//                   pageNumber = currentPage - 2 + i;
//                 }

//                 return (
//                   <button
//                     key={pageNumber}
//                     className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                     onClick={() => handlePageClick(pageNumber)}
//                   >
//                     {pageNumber}
//                   </button>
//                 );
//               })}
//             </div>
//             <button
//               className="pagination-btn next"
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//             >
//               Next <FiChevronRight />
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Notifications */}
//       {error && (
//         <div className="notification error">
//           <FiAlertCircle /> {error}
//           <button className="close-notification" onClick={() => setError(null)}>
//             <FiX />
//           </button>
//         </div>
//       )}

//       {success && (
//         <div className="notification success">
//           <FiCheck /> {success}
//           <button className="close-notification" onClick={() => setSuccess(null)}>
//             <FiX />
//           </button>
//         </div>
//       )}

//       {/* View Terms Modal */}
//       {viewingTerms && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content view-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <div className="modal-title-section">
//                 <h2>{viewingTerms.title}</h2>
//                 <div className="modal-subtitle">
//                   <span className="type-badge" style={{ backgroundColor: viewingTerms.typeColor + '15', color: viewingTerms.typeColor }}>
//                     {viewingTerms.typeIcon} {viewingTerms.typeLabel}
//                   </span>
//                   <span className="version-badge">Version {viewingTerms.version}</span>
//                 </div>
//               </div>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 <FiX />
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="terms-metadata">
//                 <div className="metadata-grid">
//                   <div className="metadata-item">
//                     <label><FiCalendar /> Effective Date</label>
//                     <span>{viewingTerms.effectiveDate}</span>
//                   </div>
//                   <div className="metadata-item">
//                     <label><FiClock /> Last Updated</label>
//                     <span>{viewingTerms.lastUpdated}</span>
//                   </div>
//                   <div className="metadata-item">
//                     <label><FiUser /> Updated By</label>
//                     <span>{viewingTerms.lastUpdatedBy}</span>
//                   </div>
//                   <div className="metadata-item">
//                     <label><FiInfo /> Status</label>
//                     {getStatusBadge(viewingTerms.isActive)}
//                   </div>
//                 </div>
//               </div>
              
//               <div className="terms-content-preview">
//                 <div className="content-header">
//                   <h3>Content</h3>
//                   <span className="section-count">{viewingTerms.sections?.length || 1} Sections</span>
//                 </div>
//                 <div className="sections-container">
//                   {viewingTerms.sections?.map((section, index) => (
//                     <div key={index} className="section-item">
//                       <div className="section-header">
//                         <h4 className="section-title">
//                           <span className="section-number">{index + 1}.</span>
//                           {section.title}
//                         </h4>
//                       </div>
//                       <div 
//                         className="section-content"
//                         dangerouslySetInnerHTML={{ __html: section.content }}
//                       />
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="btn btn-secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* History Modal */}
//       {showHistoryModal && selectedHistory && (
//         <div className="modal-overlay" onClick={closeHistoryModal}>
//           <div className="modal-content history-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <div className="modal-title-section">
//                 <h2>Version History</h2>
//                 <p className="modal-subtitle">{selectedHistory.termTitle}</p>
//               </div>
//               <button className="modal-close-btn" onClick={closeHistoryModal}>
//                 <FiX />
//               </button>
//             </div>
//             <div className="modal-body">
//               {selectedHistory.history.length > 0 ? (
//                 <div className="history-timeline">
//                   {selectedHistory.history
//                     .sort((a, b) => b.version - a.version)
//                     .map((version, index) => (
//                       <div key={index} className="timeline-item">
//                         <div className="timeline-marker">
//                           <div className="marker-dot"></div>
//                           {index < selectedHistory.history.length - 1 && (
//                             <div className="timeline-line"></div>
//                           )}
//                         </div>
//                         <div className="timeline-content">
//                           <div className="version-header">
//                             <div className="version-left">
//                               <span className="version-number">Version {version.version}</span>
//                               <span className="version-date">
//                                 {new Date(version.updatedAt || version.createdAt).toLocaleDateString('en-US', {
//                                   year: 'numeric',
//                                   month: 'short',
//                                   day: 'numeric',
//                                   hour: '2-digit',
//                                   minute: '2-digit'
//                                 })}
//                               </span>
//                             </div>
//                             <div className="version-right">
//                               <span className={`status-badge ${version.isActive ? 'active' : 'inactive'}`}>
//                                 {version.isActive ? 'Active' : 'Inactive'}
//                               </span>
//                             </div>
//                           </div>
//                           {version.changeReason && (
//                             <div className="change-reason">
//                               <strong>Change Reason:</strong> {version.changeReason}
//                             </div>
//                           )}
//                           {version.updatedBy && (
//                             <div className="updated-by">
//                               <FiUser /> Updated by: {version.updatedBy.name || 'System'}
//                             </div>
//                           )}
//                           <div className="version-preview">
//                             <div className="preview-title">{version.title}</div>
//                             <div className="preview-content">
//                               {version.sections && version.sections.length > 0 ? (
//                                 version.sections.slice(0, 2).map((section, idx) => (
//                                   <div key={idx} className="preview-section">
//                                     <strong>{section.title}</strong>
//                                     <p>{section.content.replace(/<[^>]*>/g, '').substring(0, 150)}...</p>
//                                   </div>
//                                 ))
//                               ) : (
//                                 <p>{version.content.replace(/<[^>]*>/g, '').substring(0, 200)}...</p>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                 </div>
//               ) : (
//                 <div className="empty-history">
//                   <FiClock className="history-icon" />
//                   <h3>No History Available</h3>
//                   <p>No version history found for this term.</p>
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button className="btn btn-secondary" onClick={closeHistoryModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Create New Modal */}
//       {showCreateModal && (
//         <div className="modal-overlay" onClick={closeCreateModal}>
//           <div className="modal-content create-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h2>Create New Terms</h2>
//               <button className="modal-close-btn" onClick={closeCreateModal}>
//                 <FiX />
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="create-form">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Type *</label>
//                     <div className="type-select-grid">
//                       {termTypes.filter(t => t.value).map(type => (
//                         <div 
//                           key={type.value}
//                           className={`type-option ${newTermsForm.type === type.value ? 'selected' : ''}`}
//                           onClick={() => setNewTermsForm({...newTermsForm, type: type.value})}
//                           style={{ borderColor: type.color }}
//                         >
//                           <span className="type-icon-large">{type.icon}</span>
//                           <span className="type-label">{type.label}</span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Title *</label>
//                     <input
//                       type="text"
//                       className="form-input"
//                       placeholder="Enter terms title..."
//                       value={newTermsForm.title}
//                       onChange={(e) => setNewTermsForm({...newTermsForm, title: e.target.value})}
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Effective Date</label>
//                     <input
//                       type="date"
//                       className="form-input"
//                       value={newTermsForm.effectiveDate}
//                       onChange={(e) => setNewTermsForm({...newTermsForm, effectiveDate: e.target.value})}
//                     />
//                   </div>
//                 </div>
                
//                 <div className="sections-editor">
//                   <div className="editor-header">
//                     <h3>Sections</h3>
//                     <button type="button" className="btn btn-sm btn-outline" onClick={handleAddSection}>
//                       <FiPlus /> Add Section
//                     </button>
//                   </div>
                  
//                   <div className="sections-list">
//                     {newTermsForm.sections.map((section, index) => (
//                       <div key={index} className="section-editor-item">
//                         <div className="section-editor-header">
//                           <h4>Section {index + 1}</h4>
//                           {newTermsForm.sections.length > 1 && (
//                             <button 
//                               type="button" 
//                               className="btn btn-sm btn-danger"
//                               onClick={() => handleRemoveSection(index)}
//                             >
//                               <FiTrash2 /> Remove
//                             </button>
//                           )}
//                         </div>
//                         <div className="form-group">
//                           <label>Header/Title *</label>
//                           <input
//                             type="text"
//                             className="form-input"
//                             placeholder="Enter section title..."
//                             value={section.title}
//                             onChange={(e) => handleSectionChange(index, 'title', e.target.value)}
//                           />
//                         </div>
//                         <div className="form-group">
//                           <label>Content/Paragraph *</label>
//                           <textarea
//                             className="form-textarea"
//                             rows="6"
//                             placeholder="Enter section content..."
//                             value={section.content}
//                             onChange={(e) => handleSectionChange(index, 'content', e.target.value)}
//                           />
//                           <div className="textarea-footer">
//                             <span className="char-count">{section.content.length} characters</span>
//                             <span className="html-tip">
//                               <FiInfo /> Supports HTML: &lt;b&gt;, &lt;i&gt;, &lt;u&gt;, &lt;a&gt;, &lt;ul&gt;, &lt;li&gt;
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="btn btn-secondary" onClick={closeCreateModal}>
//                 Cancel
//               </button>
//               <button className="btn btn-primary" onClick={handleCreateSubmit}>
//                 Create Terms
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Modal */}
//       {showEditModal && (
//         <div className="modal-overlay" onClick={closeEditModal}>
//           <div className="modal-content edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h2>Edit Terms and Conditions</h2>
//               <button className="modal-close-btn" onClick={closeEditModal}>
//                 <FiX />
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Title *</label>
//                     <input
//                       type="text"
//                       className="form-input"
//                       value={editForm.title}
//                       onChange={(e) => setEditForm({...editForm, title: e.target.value})}
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Effective Date</label>
//                     <input
//                       type="date"
//                       className="form-input"
//                       value={editForm.effectiveDate}
//                       onChange={(e) => setEditForm({...editForm, effectiveDate: e.target.value})}
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Status</label>
//                     <div className="status-toggle">
//                       <label className={`toggle-label ${editForm.isActive ? 'active' : ''}`}>
//                         <input
//                           type="checkbox"
//                           checked={editForm.isActive}
//                           onChange={(e) => setEditForm({...editForm, isActive: e.target.checked})}
//                         />
//                         <span className="toggle-slider"></span>
//                         <span className="toggle-text">{editForm.isActive ? 'Active' : 'Inactive'}</span>
//                       </label>
//                     </div>
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Change Reason *</label>
//                     <input
//                       type="text"
//                       className="form-input"
//                       placeholder="Explain why you're making these changes..."
//                       value={editForm.changeReason}
//                       onChange={(e) => setEditForm({...editForm, changeReason: e.target.value})}
//                     />
//                   </div>
//                 </div>
                
//                 <div className="sections-editor">
//                   <div className="editor-header">
//                     <h3>Sections ({editForm.sections?.length || 0})</h3>
//                     <button type="button" className="btn btn-sm btn-outline" onClick={handleAddEditSection}>
//                       <FiPlus /> Add Section
//                     </button>
//                   </div>
                  
//                   <div className="sections-list">
//                     {editForm.sections?.map((section, index) => (
//                       <div key={index} className="section-editor-item">
//                         <div className="section-editor-header">
//                           <h4>Section {index + 1}</h4>
//                           {editForm.sections.length > 1 && (
//                             <button 
//                               type="button" 
//                               className="btn btn-sm btn-danger"
//                               onClick={() => handleRemoveEditSection(index)}
//                             >
//                               <FiTrash2 /> Remove
//                             </button>
//                           )}
//                         </div>
//                         <div className="form-group">
//                           <label>Header/Title *</label>
//                           <input
//                             type="text"
//                             className="form-input"
//                             value={section.title}
//                             onChange={(e) => handleEditSectionChange(index, 'title', e.target.value)}
//                           />
//                         </div>
//                         <div className="form-group">
//                           <label>Content/Paragraph *</label>
//                           <textarea
//                             className="form-textarea"
//                             rows="6"
//                             value={section.content}
//                             onChange={(e) => handleEditSectionChange(index, 'content', e.target.value)}
//                           />
//                           <div className="textarea-footer">
//                             <span className="char-count">{section.content.length} characters</span>
//                             <span className="html-tip">
//                               <FiInfo /> Supports HTML: &lt;b&gt;, &lt;i&gt;, &lt;u&gt;, &lt;a&gt;, &lt;ul&gt;, &lt;li&gt;
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="btn btn-secondary" onClick={closeEditModal}>
//                 Cancel
//               </button>
//               <button className="btn btn-primary" onClick={handleSaveEdit}>
//                 Update Terms
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TermsAndConditions;

// components/TermsAndConditions.jsx
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { 
  getAllTerms, 
  getTermsById,
  createTerms, 
  updateTerms, 
  toggleTermsStatus,
  getTermsHistory 
} from '../../Services/Operations/ProductAPI';
import '../../Styles/ManagementPages.css';
import '../../Styles/TermsManage.css';

// Icons
import { 
  FiEye, FiEdit2, FiClock, FiToggleLeft, FiToggleRight,
  FiSearch, FiFilter, FiRefreshCw, FiDownload, FiPlus,
  FiTrash2, FiChevronLeft, FiChevronRight, FiX,
  FiCheck, FiAlertCircle, FiInfo, FiFileText,
  FiCalendar, FiUser, FiTag, FiLayers
} from 'react-icons/fi';

// Skeleton Components
const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="stat-icon skeleton-icon"></div>
    <div className="stat-content">
      <div className="skeleton-value"></div>
      <div className="skeleton-title"></div>
    </div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge-small"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="terms-table-container skeleton">
    <div className="table-responsive">
      <table className="modern-table">
        <thead>
          <tr>
            <th className="text-center">#</th>
            <th>Type</th>
            <th>Title & Details</th>
            <th className="text-center">Version</th>
            <th className="text-center">Status</th>
            <th>Last Updated</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
            <SkeletonTableRow key={i} />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modal-content view-modal skeleton-modal">
      <div className="modal-header">
        <div className="modal-title-section">
          <div className="skeleton-title"></div>
          <div className="skeleton-subtitle"></div>
        </div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        <div className="terms-metadata">
          <div className="metadata-grid">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="metadata-item">
                <div className="skeleton-label"></div>
                <div className="skeleton-value"></div>
              </div>
            ))}
          </div>
        </div>
        <div className="terms-content-preview">
          <div className="content-header">
            <div className="skeleton-subtitle"></div>
          </div>
          <div className="sections-container">
            {[1, 2, 3].map((i) => (
              <div key={i} className="section-item">
                <div className="skeleton-section-header"></div>
                <div className="skeleton-section-content"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const SkeletonFormModal = () => (
  <div className="modal-overlay">
    <div className="modal-content create-modal skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        <div className="create-form">
          <div className="form-grid">
            {[1, 2, 3].map((i) => (
              <div key={i} className="form-group">
                <div className="skeleton-label"></div>
                <div className="skeleton-input"></div>
              </div>
            ))}
          </div>
          <div className="sections-editor">
            <div className="editor-header">
              <div className="skeleton-subtitle"></div>
              <div className="skeleton-button-small"></div>
            </div>
            <div className="sections-list">
              {[1, 2].map((i) => (
                <div key={i} className="section-editor-item">
                  <div className="section-editor-header">
                    <div className="skeleton-label-small"></div>
                    <div className="skeleton-button-small"></div>
                  </div>
                  <div className="form-group">
                    <div className="skeleton-label"></div>
                    <div className="skeleton-input"></div>
                  </div>
                  <div className="form-group">
                    <div className="skeleton-label"></div>
                    <div className="skeleton-textarea"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const TermsAndConditions = () => {
  const { token } = useSelector(state => state.user);
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('');
  const [editingTerms, setEditingTerms] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingTerms, setViewingTerms] = useState(null);
  const [viewingHistory, setViewingHistory] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [newTermsForm, setNewTermsForm] = useState({
    type: '',
    title: '',
    sections: [{ title: '', content: '' }],
    effectiveDate: new Date().toISOString().split('T')[0]
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalTerms, setTotalTerms] = useState(0);
  const [pageSize] = useState(10);

  // Types of terms
  const termTypes = [
    { value: '', label: 'All Types', icon: '📄', color: '#6366f1' },
    { value: 'general', label: 'General Terms', icon: '📋', color: '#10b981' },
    { value: 'passenger', label: 'Passenger Terms', icon: '👤', color: '#3b82f6' },
    { value: 'bus_owner', label: 'Bus Owner Terms', icon: '🚌', color: '#f59e0b' },
    { value: 'privacy', label: 'Privacy Policy', icon: '🔒', color: '#8b5cf6' },
    { value: 'cookie', label: 'Cookie Policy', icon: '🍪', color: '#ec4899' },
    { value: 'refund', label: 'Refund Policy', icon: '💸', color: '#ef4444' }
  ];

  useEffect(() => {
    fetchTerms();
  }, [currentPage, searchTerm, filterType]);

  const fetchTerms = async () => {
    try {
      setLoading(true);
      const response = await getAllTerms(token, currentPage, pageSize, filterType, searchTerm);

      if (response && response.success) {
        const transformedTerms = response.terms.map((term, index) => ({
          id: term._id || term.id,
          serialNo: (currentPage - 1) * pageSize + index + 1,
          type: term.type,
          typeLabel: getTypeLabel(term.type),
          typeColor: getTypeColor(term.type),
          typeIcon: getTypeIcon(term.type),
          title: term.title,
          version: term.version,
          isActive: term.isActive,
          effectiveDate: new Date(term.effectiveDate).toLocaleDateString('en-US'),
          lastUpdated: new Date(term.updatedAt || term.lastUpdatedAt).toLocaleDateString('en-US'),
          lastUpdatedBy: term.lastUpdatedBy?.name || 'System Admin',
          content: term.content
        }));

        setTerms(transformedTerms);
        setTotalPages(response.totalPages || 1);
        setTotalTerms(response.total || 0);
      }
    } catch (err) {
      setError('Failed to fetch terms and conditions.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getTypeLabel = (type) => {
    const typeMap = {
      'general': 'General Terms',
      'passenger': 'Passenger Terms',
      'bus_owner': 'Bus Owner Terms',
      'privacy': 'Privacy Policy',
      'cookie': 'Cookie Policy',
      'refund': 'Refund Policy'
    };
    return typeMap[type] || type;
  };

  const getTypeColor = (type) => {
    const colorMap = {
      'general': '#10b981',
      'passenger': '#3b82f6',
      'bus_owner': '#f59e0b',
      'privacy': '#8b5cf6',
      'cookie': '#ec4899',
      'refund': '#ef4444'
    };
    return colorMap[type] || '#6b7280';
  };

  const getTypeIcon = (type) => {
    const iconMap = {
      'general': '📋',
      'passenger': '👤',
      'bus_owner': '🚌',
      'privacy': '🔒',
      'cookie': '🍪',
      'refund': '💸'
    };
    return iconMap[type] || '📄';
  };

  const handleViewTerms = async (term) => {
    try {
      setIsFetchingDetails(true);
      const response = await getTermsById(term.id, token);
      if (response.success) {
        const sections = parseContentToSections(response.terms.content);
        setViewingTerms({
          ...term,
          sections: sections.length > 0 ? sections : [{ title: 'Full Terms', content: response.terms.content }]
        });
      }
    } catch (err) {
      setError('Failed to fetch term details.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const parseContentToSections = (content) => {
    const sections = [];
    if (!content) return sections;
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const sectionElements = doc.querySelectorAll('.terms-section');
    
    if (sectionElements.length > 0) {
      sectionElements.forEach((sectionEl, index) => {
        const titleEl = sectionEl.querySelector('.section-title');
        const contentEl = sectionEl.querySelector('.section-content');
        
        if (titleEl && contentEl) {
          const titleText = titleEl.textContent.replace(/^\d+\.\s*/, '');
          sections.push({
            title: titleText,
            content: contentEl.innerHTML
          });
        }
      });
    }
    
    return sections;
  };

  const handleViewHistory = async (termId, termTitle) => {
    try {
      setIsFetchingDetails(true);
      const response = await getTermsHistory(termId, token);
      if (response.success) {
        setSelectedHistory({
          termId,
          termTitle,
          history: response.history || []
        });
        setShowHistoryModal(true);
      }
    } catch (err) {
      setError('Failed to fetch history.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleCreateNew = () => {
    setShowCreateModal(true);
    setNewTermsForm({
      type: '',
      title: '',
      sections: [
        { 
          title: 'Acceptance of Terms', 
          content: 'By accessing and using this website, you agree to be bound by these terms and conditions.' 
        },
        { 
          title: 'User Responsibilities', 
          content: 'Users must provide accurate information and use the service responsibly.' 
        }
      ],
      effectiveDate: new Date().toISOString().split('T')[0]
    });
  };

  const handleAddSection = () => {
    setNewTermsForm({
      ...newTermsForm,
      sections: [...newTermsForm.sections, { title: '', content: '' }]
    });
  };

  const handleRemoveSection = (index) => {
    if (newTermsForm.sections.length > 1) {
      const newSections = [...newTermsForm.sections];
      newSections.splice(index, 1);
      setNewTermsForm({
        ...newTermsForm,
        sections: newSections
      });
    }
  };

  const handleSectionChange = (index, field, value) => {
    const newSections = [...newTermsForm.sections];
    newSections[index][field] = value;
    setNewTermsForm({
      ...newTermsForm,
      sections: newSections
    });
  };

  const handleCreateSubmit = async () => {
    try {
      setError(null);
      
      if (!newTermsForm.type || !newTermsForm.title || !newTermsForm.sections.length) {
        setError('Please fill all required fields');
        return;
      }

      for (let i = 0; i < newTermsForm.sections.length; i++) {
        if (!newTermsForm.sections[i].title.trim() || !newTermsForm.sections[i].content.trim()) {
          setError(`Please fill both header and content for section ${i + 1}`);
          return;
        }
      }

      const response = await createTerms(newTermsForm, token);
      
      if (response.success) {
        setSuccess('Terms and conditions created successfully!');
        setShowCreateModal(false);
        fetchTerms();
        setTimeout(() => setSuccess(null), 3000);
      } else {
        setError(response.message || 'Failed to create terms');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create terms');
    }
  };

  const handleEditTerms = async (term) => {
    try {
      setIsFetchingDetails(true);
      const response = await getTermsById(term.id, token);
      if (response.success) {
        const sections = parseContentToSections(response.terms.content);
        setEditingTerms(term.id);
        setEditForm({
          title: term.title,
          sections: sections.length > 0 ? sections : [{ title: 'Terms and Conditions', content: response.terms.content }],
          isActive: term.isActive,
          effectiveDate: new Date(term.effectiveDate).toISOString().split('T')[0],
          changeReason: ''
        });
        setShowEditModal(true);
      }
    } catch (err) {
      setError('Failed to load term for editing.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleEditSectionChange = (index, field, value) => {
    const newSections = [...editForm.sections];
    newSections[index][field] = value;
    setEditForm({
      ...editForm,
      sections: newSections
    });
  };

  const handleAddEditSection = () => {
    setEditForm({
      ...editForm,
      sections: [...editForm.sections, { title: '', content: '' }]
    });
  };

  const handleRemoveEditSection = (index) => {
    if (editForm.sections.length > 1) {
      const newSections = [...editForm.sections];
      newSections.splice(index, 1);
      setEditForm({
        ...editForm,
        sections: newSections
      });
    }
  };

  const handleSaveEdit = async () => {
    try {
      setError(null);

      if (!editForm.changeReason) {
        setError('Please provide a change reason for this update');
        return;
      }

      for (let i = 0; i < editForm.sections.length; i++) {
        if (!editForm.sections[i].title.trim() || !editForm.sections[i].content.trim()) {
          setError(`Please fill both header and content for section ${i + 1}`);
          return;
        }
      }

      const updateData = {
        title: editForm.title,
        sections: editForm.sections,
        effectiveDate: editForm.effectiveDate,
        isActive: editForm.isActive,
        changeReason: editForm.changeReason
      };

      const response = await updateTerms(editingTerms, updateData, token);

      if (response.success) {
        setSuccess('Terms updated successfully!');
        setEditingTerms(null);
        setEditForm({});
        setShowEditModal(false);
        fetchTerms();
        setTimeout(() => setSuccess(null), 3000);
      } else {
        setError(response.message || 'Failed to update terms');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update terms');
    }
  };

  const handleToggleStatus = async (termId, currentStatus) => {
    try {
      setError(null);
      const response = await toggleTermsStatus(termId, token);
      
      if (response.success) {
        setSuccess(`Terms ${currentStatus ? 'deactivated' : 'activated'} successfully!`);
        fetchTerms();
        setTimeout(() => setSuccess(null), 3000);
      }
    } catch (err) {
      setError('Failed to update status');
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleTypeFilter = (e) => {
    setFilterType(e.target.value);
    setCurrentPage(1);
  };

  const handleRefresh = () => {
    setCurrentPage(1);
    fetchTerms();
  };

  const handleExportCSV = () => {
    if (terms.length === 0) {
      alert('No data to export');
      return;
    }

    const headers = ['ID', 'Type', 'Title', 'Version', 'Status', 'Effective Date', 'Last Updated', 'Updated By'];
    const csvData = terms.map(term => [
      term.id,
      term.typeLabel,
      term.title,
      term.version,
      term.isActive ? 'Active' : 'Inactive',
      term.effectiveDate,
      term.lastUpdated,
      term.lastUpdatedBy
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `terms-and-conditions-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    alert('CSV exported successfully!');
  };

  const getStatusBadge = (isActive) => {
    return (
      <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
        <span className="status-dot"></span>
        {isActive ? 'Active' : 'Inactive'}
      </span>
    );
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const closeViewModal = () => {
    setViewingTerms(null);
  };

  const closeHistoryModal = () => {
    setShowHistoryModal(false);
    setSelectedHistory(null);
  };

  const closeCreateModal = () => {
    setShowCreateModal(false);
    setNewTermsForm({
      type: '',
      title: '',
      sections: [{ title: '', content: '' }],
      effectiveDate: new Date().toISOString().split('T')[0]
    });
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditingTerms(null);
    setEditForm({});
  };

  const filterTerms = terms.filter(term => 
    term.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    term.typeLabel.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Loading state with skeletons
  if (loading && terms.length === 0) {
    return (
      <div className="terms-management-page">
        <div className="terms-header">
          <div className="header-left">
            <div className="skeleton-header-title"></div>
            <div className="skeleton-header-subtitle"></div>
          </div>
          <div className="header-right">
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="terms-stats-grid">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <div className="filters-section">
          <div className="search-box">
            <div className="skeleton-search"></div>
          </div>
          <div className="filter-actions">
            <div className="skeleton-select"></div>
            <div className="skeleton-button-small"></div>
            <div className="skeleton-button-small"></div>
          </div>
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="terms-management-page">
      {/* Header */}
      <div className="terms-header">
        <div className="header-left">
          <h1><FiFileText /> Terms & Conditions</h1>
          <p className="subtitle">Manage all terms, policies, and agreements</p>
        </div>
        <div className="header-right">
          <button className="btn btn-primary" onClick={handleCreateNew}>
            <FiPlus /> Create New
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="terms-stats-grid">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <FiLayers />
          </div>
          <div className="stat-content">
            <h3>{totalTerms}</h3>
            <p>Total Terms</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)' }}>
            <FiCheck />
          </div>
          <div className="stat-content">
            <h3>{terms.filter(t => t.isActive).length}</h3>
            <p>Active</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)' }}>
            <FiTag />
          </div>
          <div className="stat-content">
            <h3>{[...new Set(terms.map(t => t.type))].length}</h3>
            <p>Types</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)' }}>
            <FiClock />
          </div>
          <div className="stat-content">
            <h3>v{Math.max(...terms.map(t => t.version || 1))}</h3>
            <p>Latest Version</p>
          </div>
        </div>
      </div>

      {/* Filters and Search */}
      <div className="filters-section">
        <div className="search-box">
          <FiSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search terms by title or type..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="search-input"
          />
        </div>
        <div className="filter-actions">
          <div className="filter-group">
            <FiFilter className="filter-icon" />
            <select
              className="filter-select"
              value={filterType}
              onChange={handleTypeFilter}
            >
              {termTypes.map(type => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>
          <button className="btn btn-secondary" onClick={handleRefresh}>
            <FiRefreshCw /> Refresh
          </button>
          <button className="btn btn-outline" onClick={handleExportCSV}>
            <FiDownload /> Export
          </button>
        </div>
      </div>

      {/* Terms Table */}
      <div className="terms-table-container">
        <div className="table-responsive">
          <table className="modern-table">
            <thead>
              <tr>
                <th className="text-center">#</th>
                <th>Type</th>
                <th>Title & Details</th>
                <th className="text-center">Version</th>
                <th className="text-center">Status</th>
                <th>Last Updated</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filterTerms.map(term => (
                <tr key={term.id}>
                  <td className="text-center">{term.serialNo}</td>
                  <td>
                    <div className="type-badge" style={{ backgroundColor: term.typeColor + '15', color: term.typeColor, borderColor: term.typeColor + '40' }}>
                      <span className="type-icon">{term.typeIcon}</span>
                      {term.typeLabel}
                    </div>
                  </td>
                  <td>
                    <div className="term-info">
                      <h4 className="term-title">{term.title}</h4>
                      <div className="term-meta">
                        <span className="meta-item">
                          <FiCalendar /> {term.effectiveDate}
                        </span>
                        <span className="meta-item">
                          <FiUser /> {term.lastUpdatedBy}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="text-center">
                    <span className="version-badge">v{term.version}</span>
                  </td>
                  <td className="text-center">
                    {getStatusBadge(term.isActive)}
                  </td>
                  <td>
                    <div className="update-info">
                      <div className="update-date">{term.lastUpdated}</div>
                    </div>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn view"
                        onClick={() => handleViewTerms(term)}
                        title="View Details"
                      >
                        <FiEye />
                      </button>
                      <button
                        className="action-btn edit"
                        onClick={() => handleEditTerms(term)}
                        title="Edit"
                      >
                        <FiEdit2 />
                      </button>
                      <button
                        className="action-btn history"
                        onClick={() => handleViewHistory(term.id, term.title)}
                        title="View History"
                      >
                        <FiClock />
                      </button>
                      <button
                        className={`action-btn ${term.isActive ? 'deactivate' : 'activate'}`}
                        onClick={() => handleToggleStatus(term.id, term.isActive)}
                        title={term.isActive ? 'Deactivate' : 'Activate'}
                      >
                        {term.isActive ? <FiToggleRight /> : <FiToggleLeft />}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {filterTerms.length === 0 && !loading && (
          <div className="empty-state">
            <div className="empty-icon">📄</div>
            <h3>No Terms Found</h3>
            <p>No terms and conditions match your search criteria.</p>
            <button className="btn btn-primary" onClick={handleCreateNew}>
              <FiPlus /> Create Your First Terms
            </button>
          </div>
        )}
      </div>

      {/* Pagination */}
      {filterTerms.length > 0 && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing <strong>{filterTerms.length}</strong> of <strong>{totalTerms}</strong> terms • Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
          </div>
          <div className="pagination-controls">
            <button
              className="pagination-btn prev"
              onClick={handlePrevPage}
              disabled={currentPage === 1}
            >
              <FiChevronLeft /> Previous
            </button>
            <div className="page-numbers">
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                let pageNumber;
                if (totalPages <= 5) {
                  pageNumber = i + 1;
                } else if (currentPage <= 3) {
                  pageNumber = i + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNumber = totalPages - 4 + i;
                } else {
                  pageNumber = currentPage - 2 + i;
                }

                return (
                  <button
                    key={pageNumber}
                    className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                    onClick={() => handlePageClick(pageNumber)}
                  >
                    {pageNumber}
                  </button>
                );
              })}
            </div>
            <button
              className="pagination-btn next"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next <FiChevronRight />
            </button>
          </div>
        </div>
      )}

      {/* Notifications */}
      {error && (
        <div className="notification error">
          <FiAlertCircle /> {error}
          <button className="close-notification" onClick={() => setError(null)}>
            <FiX />
          </button>
        </div>
      )}

      {success && (
        <div className="notification success">
          <FiCheck /> {success}
          <button className="close-notification" onClick={() => setSuccess(null)}>
            <FiX />
          </button>
        </div>
      )}

      {/* View Terms Modal */}
      {viewingTerms && !isFetchingDetails && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content view-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title-section">
                <h2>{viewingTerms.title}</h2>
                <div className="modal-subtitle">
                  <span className="type-badge" style={{ backgroundColor: viewingTerms.typeColor + '15', color: viewingTerms.typeColor }}>
                    {viewingTerms.typeIcon} {viewingTerms.typeLabel}
                  </span>
                  <span className="version-badge">Version {viewingTerms.version}</span>
                </div>
              </div>
              <button className="modal-close-btn" onClick={closeViewModal}>
                <FiX />
              </button>
            </div>
            <div className="modal-body">
              <div className="terms-metadata">
                <div className="metadata-grid">
                  <div className="metadata-item">
                    <label><FiCalendar /> Effective Date</label>
                    <span>{viewingTerms.effectiveDate}</span>
                  </div>
                  <div className="metadata-item">
                    <label><FiClock /> Last Updated</label>
                    <span>{viewingTerms.lastUpdated}</span>
                  </div>
                  <div className="metadata-item">
                    <label><FiUser /> Updated By</label>
                    <span>{viewingTerms.lastUpdatedBy}</span>
                  </div>
                  <div className="metadata-item">
                    <label><FiInfo /> Status</label>
                    {getStatusBadge(viewingTerms.isActive)}
                  </div>
                </div>
              </div>
              
              <div className="terms-content-preview">
                <div className="content-header">
                  <h3>Content</h3>
                  <span className="section-count">{viewingTerms.sections?.length || 1} Sections</span>
                </div>
                <div className="sections-container">
                  {viewingTerms.sections?.map((section, index) => (
                    <div key={index} className="section-item">
                      <div className="section-header">
                        <h4 className="section-title">
                          <span className="section-number">{index + 1}.</span>
                          {section.title}
                        </h4>
                      </div>
                      <div 
                        className="section-content"
                        dangerouslySetInnerHTML={{ __html: section.content }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeViewModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for view modal */}
      {viewingTerms && isFetchingDetails && <SkeletonModal />}

      {/* History Modal */}
      {showHistoryModal && selectedHistory && !isFetchingDetails && (
        <div className="modal-overlay" onClick={closeHistoryModal}>
          <div className="modal-content history-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title-section">
                <h2>Version History</h2>
                <p className="modal-subtitle">{selectedHistory.termTitle}</p>
              </div>
              <button className="modal-close-btn" onClick={closeHistoryModal}>
                <FiX />
              </button>
            </div>
            <div className="modal-body">
              {selectedHistory.history.length > 0 ? (
                <div className="history-timeline">
                  {selectedHistory.history
                    .sort((a, b) => b.version - a.version)
                    .map((version, index) => (
                      <div key={index} className="timeline-item">
                        <div className="timeline-marker">
                          <div className="marker-dot"></div>
                          {index < selectedHistory.history.length - 1 && (
                            <div className="timeline-line"></div>
                          )}
                        </div>
                        <div className="timeline-content">
                          <div className="version-header">
                            <div className="version-left">
                              <span className="version-number">Version {version.version}</span>
                              <span className="version-date">
                                {new Date(version.updatedAt || version.createdAt).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'short',
                                  day: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                })}
                              </span>
                            </div>
                            <div className="version-right">
                              <span className={`status-badge ${version.isActive ? 'active' : 'inactive'}`}>
                                {version.isActive ? 'Active' : 'Inactive'}
                              </span>
                            </div>
                          </div>
                          {version.changeReason && (
                            <div className="change-reason">
                              <strong>Change Reason:</strong> {version.changeReason}
                            </div>
                          )}
                          {version.updatedBy && (
                            <div className="updated-by">
                              <FiUser /> Updated by: {version.updatedBy.name || 'System'}
                            </div>
                          )}
                          <div className="version-preview">
                            <div className="preview-title">{version.title}</div>
                            <div className="preview-content">
                              {version.sections && version.sections.length > 0 ? (
                                version.sections.slice(0, 2).map((section, idx) => (
                                  <div key={idx} className="preview-section">
                                    <strong>{section.title}</strong>
                                    <p>{section.content.replace(/<[^>]*>/g, '').substring(0, 150)}...</p>
                                  </div>
                                ))
                              ) : (
                                <p>{version.content.replace(/<[^>]*>/g, '').substring(0, 200)}...</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <div className="empty-history">
                  <FiClock className="history-icon" />
                  <h3>No History Available</h3>
                  <p>No version history found for this term.</p>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeHistoryModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Create New Modal */}
      {showCreateModal && !isFetchingDetails && (
        <div className="modal-overlay" onClick={closeCreateModal}>
          <div className="modal-content create-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Create New Terms</h2>
              <button className="modal-close-btn" onClick={closeCreateModal}>
                <FiX />
              </button>
            </div>
            <div className="modal-body">
              <div className="create-form">
                <div className="form-grid">
                  <div className="form-group">
                    <label>Type *</label>
                    <div className="type-select-grid">
                      {termTypes.filter(t => t.value).map(type => (
                        <div 
                          key={type.value}
                          className={`type-option ${newTermsForm.type === type.value ? 'selected' : ''}`}
                          onClick={() => setNewTermsForm({...newTermsForm, type: type.value})}
                          style={{ borderColor: type.color }}
                        >
                          <span className="type-icon-large">{type.icon}</span>
                          <span className="type-label">{type.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label>Title *</label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Enter terms title..."
                      value={newTermsForm.title}
                      onChange={(e) => setNewTermsForm({...newTermsForm, title: e.target.value})}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Effective Date</label>
                    <input
                      type="date"
                      className="form-input"
                      value={newTermsForm.effectiveDate}
                      onChange={(e) => setNewTermsForm({...newTermsForm, effectiveDate: e.target.value})}
                    />
                  </div>
                </div>
                
                <div className="sections-editor">
                  <div className="editor-header">
                    <h3>Sections</h3>
                    <button type="button" className="btn btn-sm btn-outline" onClick={handleAddSection}>
                      <FiPlus /> Add Section
                    </button>
                  </div>
                  
                  <div className="sections-list">
                    {newTermsForm.sections.map((section, index) => (
                      <div key={index} className="section-editor-item">
                        <div className="section-editor-header">
                          <h4>Section {index + 1}</h4>
                          {newTermsForm.sections.length > 1 && (
                            <button 
                              type="button" 
                              className="btn btn-sm btn-danger"
                              onClick={() => handleRemoveSection(index)}
                            >
                              <FiTrash2 /> Remove
                            </button>
                          )}
                        </div>
                        <div className="form-group">
                          <label>Header/Title *</label>
                          <input
                            type="text"
                            className="form-input"
                            placeholder="Enter section title..."
                            value={section.title}
                            onChange={(e) => handleSectionChange(index, 'title', e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>Content/Paragraph *</label>
                          <textarea
                            className="form-textarea"
                            rows="6"
                            placeholder="Enter section content..."
                            value={section.content}
                            onChange={(e) => handleSectionChange(index, 'content', e.target.value)}
                          />
                          <div className="textarea-footer">
                            <span className="char-count">{section.content.length} characters</span>
                            <span className="html-tip">
                              <FiInfo /> Supports HTML: &lt;b&gt;, &lt;i&gt;, &lt;u&gt;, &lt;a&gt;, &lt;ul&gt;, &lt;li&gt;
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeCreateModal}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleCreateSubmit}>
                Create Terms
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for create modal */}
      {showCreateModal && isFetchingDetails && <SkeletonFormModal />}

      {/* Edit Modal */}
      {showEditModal && !isFetchingDetails && (
        <div className="modal-overlay" onClick={closeEditModal}>
          <div className="modal-content edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Edit Terms and Conditions</h2>
              <button className="modal-close-btn" onClick={closeEditModal}>
                <FiX />
              </button>
            </div>
            <div className="modal-body">
              <div className="edit-form">
                <div className="form-grid">
                  <div className="form-group">
                    <label>Title *</label>
                    <input
                      type="text"
                      className="form-input"
                      value={editForm.title}
                      onChange={(e) => setEditForm({...editForm, title: e.target.value})}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Effective Date</label>
                    <input
                      type="date"
                      className="form-input"
                      value={editForm.effectiveDate}
                      onChange={(e) => setEditForm({...editForm, effectiveDate: e.target.value})}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Status</label>
                    <div className="status-toggle">
                      <label className={`toggle-label ${editForm.isActive ? 'active' : ''}`}>
                        <input
                          type="checkbox"
                          checked={editForm.isActive}
                          onChange={(e) => setEditForm({...editForm, isActive: e.target.checked})}
                        />
                        <span className="toggle-slider"></span>
                        <span className="toggle-text">{editForm.isActive ? 'Active' : 'Inactive'}</span>
                      </label>
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label>Change Reason *</label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Explain why you're making these changes..."
                      value={editForm.changeReason}
                      onChange={(e) => setEditForm({...editForm, changeReason: e.target.value})}
                    />
                  </div>
                </div>
                
                <div className="sections-editor">
                  <div className="editor-header">
                    <h3>Sections ({editForm.sections?.length || 0})</h3>
                    <button type="button" className="btn btn-sm btn-outline" onClick={handleAddEditSection}>
                      <FiPlus /> Add Section
                    </button>
                  </div>
                  
                  <div className="sections-list">
                    {editForm.sections?.map((section, index) => (
                      <div key={index} className="section-editor-item">
                        <div className="section-editor-header">
                          <h4>Section {index + 1}</h4>
                          {editForm.sections.length > 1 && (
                            <button 
                              type="button" 
                              className="btn btn-sm btn-danger"
                              onClick={() => handleRemoveEditSection(index)}
                            >
                              <FiTrash2 /> Remove
                            </button>
                          )}
                        </div>
                        <div className="form-group">
                          <label>Header/Title *</label>
                          <input
                            type="text"
                            className="form-input"
                            value={section.title}
                            onChange={(e) => handleEditSectionChange(index, 'title', e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>Content/Paragraph *</label>
                          <textarea
                            className="form-textarea"
                            rows="6"
                            value={section.content}
                            onChange={(e) => handleEditSectionChange(index, 'content', e.target.value)}
                          />
                          <div className="textarea-footer">
                            <span className="char-count">{section.content.length} characters</span>
                            <span className="html-tip">
                              <FiInfo /> Supports HTML: &lt;b&gt;, &lt;i&gt;, &lt;u&gt;, &lt;a&gt;, &lt;ul&gt;, &lt;li&gt;
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeEditModal}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSaveEdit}>
                Update Terms
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for edit modal */}
      {showEditModal && isFetchingDetails && <SkeletonFormModal />}
    </div>
  );
};

export default TermsAndConditions;